import { faCheckCircle, faCogs, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Dropdown, DropdownButton, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import "./NetworkProfileInfoCard.css";

class NetworkProfileInfoCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getNameOfCloudProfile(cloudProfileId) {
    return this.props.cloudProfiles.find(c => c.id === cloudProfileId)?.name;
  }

  render() {
    const { t } = this.props;

    const body = (
      <>
        <Row className="pageTitle">
          <Col>
            <h2>{t("SingleNetworkProfile.Title")}</h2>
          </Col>
          <Col>
            <div style={{ float: "right" }}>
              <DropdownButton
                onClick={event => event.stopPropagation()}
                id="dropdown-basic-button"
                title={<FontAwesomeIcon icon={faCogs} />}
                className="btn-green"
              >
                <Dropdown.Item onClick={this.props.onEdit}>
                  {t("SingleNetworkProfile.ActionCell.EditOption")}
                </Dropdown.Item>
              </DropdownButton>
            </div>
          </Col>
        </Row>
        <Row className="mb-4">
          <Col>
            <div>
              <b>{t("SingleNetworkProfile.BasicInformation.Name")}:</b>{" "}
              {this.props.networkProfile.name}
            </div>
            <div>
              <b>{t("SingleNetworkProfile.BasicInformation.IsPublished")}:</b>{" "}
              <FontAwesomeIcon
                className={
                  this.props.networkProfile.isPublished
                    ? "published"
                    : "not-published"
                }
                icon={
                  this.props.networkProfile.isPublished
                    ? faCheckCircle
                    : faTimesCircle
                }
              />
            </div>
          </Col>
          <Col style={{ borderLeft: "1px solid gray" }}>
            <div>
              <b>{t("SingleNetworkProfile.BasicInformation.CloudProfile")}:</b>{" "}
              {this.getNameOfCloudProfile(
                this.props.networkProfile.cloudProfileId
              )}
            </div>
          </Col>
        </Row>
      </>
    );

    return <div>{body}</div>;
  }
}

export default withTranslation()(NetworkProfileInfoCard);
